import { useEffect, useState } from "react";

export const useIsDraggingFile = () => {
    const [isDragging, setIsDragging] = useState(false);

    useEffect(() => {
        let dragCounter = 0;

        const handleDragEnter = (e: DragEvent) => {
            e.preventDefault();

            if (e.dataTransfer?.types.includes("Files")) {
                dragCounter++;
                setIsDragging(true);
            }
        };

        const handleDragLeave = (e: DragEvent) => {
            e.preventDefault();

            if (e.dataTransfer?.types.includes("Files")) {
                dragCounter--;
                if (dragCounter <= 0) {
                    setIsDragging(false);
                }
            }
        };

        const handleDrop = () => {
            dragCounter = 0;
            setIsDragging(false);
        };

        const handleDragOver = (e: DragEvent) => {
            e.preventDefault();
        };

        window.addEventListener("dragenter", handleDragEnter);
        window.addEventListener("dragleave", handleDragLeave);
        window.addEventListener("drop", handleDrop);
        window.addEventListener("dragover", handleDragOver);

        return () => {
            window.removeEventListener("dragenter", handleDragEnter);
            window.removeEventListener("dragleave", handleDragLeave);
            window.removeEventListener("drop", handleDrop);
            window.removeEventListener("dragover", handleDragOver);
        };
    }, []);

    return isDragging;
};
